import React,{useState} from 'react'
import '../registarcliente.css';
import axios from 'axios';
import {toast,ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Form,  Result,Input, Button, message, theme,Row,Select, Col,Breadcrumb, Layout,Typography,Steps,DatePicker } from 'antd';
import { SearchOutlined, BarsOutlined, AppstoreOutlined } from '@ant-design/icons';

toast.configure()
const {Option}=Select
function RegistarCliente() {
    const [current, setCurrent] = useState(0);
    const [info,setInfo]=useState({nome:"",nuit:"",bi:"",telefone:"",provincia:"Maputo cidade",email:"",contador:"",morada:"",bairro:"Aeroporto A",cidade:"Maputo cidade",distrito:"Nlhamankulu"});
    const [error,setError]=useState(null);
    const [dados,setDados]=useState(null);
    const [form,setForm]=useState(false);
    const [meter,setMeter]=useState(null);
    const onChange = (value) => {
        console.log("onChange:", value);
        
        if (current!=0){
          if (current==1){
            if(value==2){
              
            }else{
              setCurrent(value);
      
            }
           } 
            else {
              setCurrent(value)
              
          } 
         
        } 
       
     
        
      };
    const Registrar=(values)=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/registarcliente/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:values
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
          setCurrent(2)
         }
       
           ).catch(e=>{
            message.error("O cliente Ja foi Registrado! ou Contador Ja esta associado a outro Cliente ")
        })
    

    }
    const RegistroHandler=e=>{
        e.preventDefault();
        Registrar();
    }
    const HandleChange=(e)=>{
        console.log("mudou");
    }
    const handleInputChange = (e) => {
      console.log(e.target.value)
      setMeter(e.target.value);

      };
      const handleSearch = () => {
        if (meter.length === 11 || meter.length === 13) {
          if (/^\d+$/.test(meter)) {
            axios({
              method: "get",
              url: `${localStorage.getItem('url')}/web/${meter}/`,
              headers: {
                'Authorization': `token ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
              }
            })
            .then(response => {
              if (response.status !== 200) {
                throw Error('Erro ao verificar o número do medidor');
              }
              return response;
            })
            .then(data => {
              setCurrent(1);
                })
            .catch(error => {
              message.error("Número do medidor não existe ou está associado a um cliente");
            });
            
         
          } else {
            // Handle the case when meter contains non-digit characters
            message.error("O número do contador deve conter apenas dígitos");

          }
          }
          else{
            message.error("Número de contador incorreto. Deve ser composto por 11 ou 13 dígitos.");

          }


      };
    const item = [
      {
        title: "pesquisa",

        style: { color: "white" },
        conteudo: (
          <>
            <Input
              placeholder="Pesquisar nr de contador"
              size="small"
              onChange={handleInputChange}
              style={{ width: 300, marginRight: 8, marginTop: "3%" }}
              allowClear
              disabled={form}
              maxLength={13}
              suffix={
                <Button
                  type="primary"
                  shape="circle"
                  icon={<SearchOutlined />}
                  onClick={handleSearch}
                />
              }
            />
          </>
        ),
      },
      {
        title: "Dados Basicos",
        conteudo: (
          <>
       
            <Form
              layout="vertical"
              name="cliente_form_name"
              onFinish={Registrar}
              requiredMark={false}
              initialValues={{
                provincia: "Maputo", // Initial value for province (you can change this)
              }}
            >
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item
                    label="Nome"
                    name="nome"
                    rules={[
                      { required: true, message: "Por favor, insira o nome!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="Nuit"
                    name="nuit"
                    rules={[
                      { required: true, message: "Por favor, insira o NUIT!" },
                      {
                        pattern: /^\d{9}$/,
                        message: "O NUIT deve conter exatamente 9 dígitos.",
                      },
                    ]}
                  >
                    <Input maxLength={9} />
                  </Form.Item>

                  <Form.Item
                    label="BI"
                    name="bi"
                    rules={[
                      { required: true, message: "Por favor, insira o BI!" },
                      {
                        pattern: /^\d{12}[A-Za-z]$/,
                        message:
                          "O BI deve conter exatamente 12 dígitos seguidos de uma letra.",
                      },
                    ]}
                  >
                    <Input maxLength={13} />
                  </Form.Item>

                  <Form.Item
                    label="Morada"
                    name="morada"
                    rules={[
                      {
                        required: true,
                        message: "Por favor, insira a morada!",
                      },
                    ]}
                  >
                    <Input  placeholder='avenida,rua,nr da casa, quarteirao...'/>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Telefone"
                    name="telefone"
                    rules={[
                      {
                        required: true,
                        message: "Por favor, insira o telefone!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="Bairro"
                    name="bairro"
                    rules={[
                      {
                        required: true,
                        message: "Por favor, selecione a província!",
                      },
                    ]}
                  >
                    <Select>
                      <Option value="Aeroporto">Aeroporto </Option>
                      <Option value="Coop PH5"> Coop PH5</Option>
                      <Option value="Coop PH6"> Cop PH6</Option>
                      <Option value="25 de Junho">25 de Junho</Option>
                      <Option value="Costa do Sol">Costa do Sol</Option>
                      <Option value="Zimpeto">Zimpeto</Option>
                      <Option value="George Dimitrov">George Dimitrov</Option>
                      <Option value="Benfica">Benfica</Option>

                      {/* Add other provinces here */}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: "Por favor, insira o email!" },
                      {
                        type: "email",
                        message: "Por favor, insira um email válido!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="Contador"
                    name="contador"
                    initialValue={meter}
                    rules={[
                      {
                        required: true,
                        message: "Por favor, insira o contador!",
                      },
                    ]}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Registar
                </Button>
              </Form.Item>
            </Form>
          </>
        ),
      },
      {
        title: "Concluido",
        conteudo:<>
        
        <Result
    status="success"
    title="Registrado com sucesso!"
    subTitle="O cliente foi registrado com sucesso!"
 
  />
        </>
      },
    ];
    return (<>
     <Steps current={current} onChange={onChange} items={item} />
     <div className="steps-content mt-1000 ">{item[current].conteudo}</div>
    </>
       
    )
}

export default RegistarCliente
